import React, { FC, useContext, useState } from "react";
import { ThemeContext } from "styled-components";
import { useScreenSize } from "../../../../hooks/useScreenSize";
import { LocationProps } from "../Location";
import { Logo, LogoProps } from "../Logo";
import { MobileMenuIcon } from "../../MobileMenuIcon";
import { NavLinksProps, NavMenu } from "../NavMenu";
import { SubNavItem } from "../SubNav";
import { User, UserProps } from "../User";
import { StyledNav, StyledNavMobile } from "./index.styled";

export interface HeaderLeftProps {
  accountAsNavLink?: boolean;
  location?: LocationProps;
  logo: LogoProps;
  navLinks: NavLinksProps;
  subNav?: SubNavItem[];
  user: UserProps;
}

export const HeaderLeft: FC<HeaderLeftProps> = ({
  accountAsNavLink,
  location,
  logo,
  navLinks,
  subNav,
  user,
}) => {
  const theme = useContext(ThemeContext);
  const [isMenuOpen, setMenuOpen] = useState(false);
  const { isDesktop } = useScreenSize();

  return (
    <>
      {!isDesktop && (
        <StyledNavMobile>
          <MobileMenuIcon
            color={theme.header?.shop?.navLinkColor}
            isOpen={isMenuOpen}
            onClick={(isOpen: boolean) => setMenuOpen(isOpen)}
          />
          <NavMenu
            hasSubNavs={!!subNav}
            isOpen={isMenuOpen}
            keepMobileMenuOpen={(isOpen: boolean) => setMenuOpen(isOpen)}
            navLinks={navLinks}
            user={user}
          />
        </StyledNavMobile>
      )}

      <Logo logo={logo} />

      {isDesktop && (
        <>
          <StyledNav>
            <NavMenu location={location} navLinks={navLinks} user={user} />
          </StyledNav>

          {/* show Account on the left in desktop view if accountAsNavLink */}
          {accountAsNavLink && <User user={user} />}
        </>
      )}
    </>
  );
};
